/**
 * Сумма в рублях числом. Бэк отдаёт деньги строкой («990.00» — `Decimal` в
 * pydantic v2), но локально собранные объекты и legacy-ответы несут число —
 * принимаем оба варианта. Нечисловое/пустое значение → 0.
 */
export function parseRubAmount(value) {
    if (value === null || value === undefined || value === "")
        return 0;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
}
/** Разделяем разряды неразрывным пробелом: 2490 → «2 490». */
export function formatRub(value) {
    return Math.round(value)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, "\u00a0");
}
